import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './postoForm';
import Map from '../common/map/mapVisualizacao';

import { setModoTela, initForm, salvar, excluir, getListaCidade, getLista, getListaRede, getListaFormaPagamento, getListaEstado } from './postoActions';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Select from '../common/form/select';
import ReactExport from 'react-export-excel-fixed-xlsx';

class Posto extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		modo: 'lista',
		ordenacao: 'data_validade_diesel'
	}

    componentWillMount() {
		this.props.getLista();
		this.props.getListaCidade();
		this.props.getListaRede();
		this.props.getListaFormaPagamento();
		this.props.getListaEstado();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'negociacao' ? (
						<Form onSubmit={this.props.salvar} negociacao />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let precoTotalAtivos = 0;
		let precoTotalNoPrazo = 0;
		let quantidadeAtivos = 0;
		let quantidadeNoPrazo = 0;

		let lista = this.props.lista.filter(item => {
			if (this.state.id_estado && item.id_estado != this.state.id_estado) {
				return false;
			}
			if (this.state.periodo) {
				if (this.state.periodo == 1 && item.dias_para_vencimento > 0) {
					return false;
				} else if (this.state.periodo == 30 && !(item.dias_para_vencimento > 0 && item.dias_para_vencimento <= 30)) {
					return false;
				} else if (this.state.periodo == 60 && !(item.dias_para_vencimento > 30 && item.dias_para_vencimento <= 60)) {
					return false;
				} else if (this.state.periodo == 90 && !(item.dias_para_vencimento > 60 && item.dias_para_vencimento <= 90)) {
					return false;
				} else if (this.state.periodo == 120 && !(item.dias_para_vencimento > 90 && item.dias_para_vencimento <= 120)) {
					return false;
				} else if (this.state.periodo == 10000 && !(item.dias_para_vencimento > 120)) {
					return false;
				}
			}
			if (this.state.pesquisar
				&& !(`${item.codigo} ${item.nome_rede} ${item.nome} ${item.telefone} ${item.cnpj} ${item.nome_cidade}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		}).map(item => {

			if (!item.desativado && !item.cancelado && parseFloat(item.preco_diesel || 0) > 0) {
				//Dentro do Prazo
				if (item.dias_para_vencimento >= 0) {
					precoTotalNoPrazo += parseFloat(item.preco_diesel || 0);
					quantidadeNoPrazo ++;
				}

				precoTotalAtivos += parseFloat(item.preco_diesel || 0);
				quantidadeAtivos ++;
			}
			
			return item;
		});

		let mediaNoPrazo = quantidadeNoPrazo > 0 ? precoTotalNoPrazo / quantidadeNoPrazo : 0;
		let mediaAtivos = quantidadeAtivos > 0 ? precoTotalAtivos / quantidadeAtivos : 0;

		lista.sort((a, b) => {
			if (this.state.ordenacao == 'preco_diesel') {
				return parseFloat(a.desativado || a.cancelado || parseFloat(a.preco_diesel || 0) <= 0 ? 10000000 : a.preco_diesel || 0) 
					< parseFloat(b.desativado || b.cancelado || parseFloat(b.preco_diesel || 0) <= 0 ? 10000000 : b.preco_diesel || 0) ? -1 : 1;
			} else {
				return 0;
			}
		});

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								disabled={this.props.permissoes.acesso_cadastro != 2}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ });
								}} />
						</Grid>
						<Grid cols='6 6 4 2'>
							<ExcelFile
								filename={'Postos'}
								element={
									<Button
										text='Exportar'
										type={'primary'}
										icon={'fa fa-download'} />
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									telefone: FormatUtils.formatarTelefone(item.telefone),
									cnpj: FormatUtils.formatarCNPJ(item.cnpj),
									data_validade_diesel: DateFormat.formatarDataSqlParaTela(item.data_validade_diesel),
									preco_diesel: parseFloat(item.preco_diesel),
									data_validade_arla: DateFormat.formatarDataSqlParaTela(item.data_validade_arla),
									prazo: item.prazo || item.prazo_rede || '',
									status: item.desativado ? 'Desativado' : (
										item.cancelado ? 'Cancelado para Negociação' : (
											item.dias_para_vencimento > 0 ? 'Dentro do Prazo' : 'Fora do Prazo'
										)
									)}))} name='Postos'>
									<ExcelColumn label='Código Atua' value='codigo' />
									<ExcelColumn label='Rede' value='nome_rede' />
									<ExcelColumn label='Nome' value='nome' />
									<ExcelColumn label='Telefone' value='telefone' />
									<ExcelColumn label='CNPJ' value='cnpj' />
									<ExcelColumn label='Cidade' value='nome_cidade' />
									<ExcelColumn label='Val. Diesel' value='data_validade_diesel' />
									<ExcelColumn label='Vlr. Diesel' value='preco_diesel' type='number' />
									<ExcelColumn label='Val. Arla' value='data_validade_arla' />
									<ExcelColumn label='Prazo' value='prazo' />
									<ExcelColumn label='Status' value='status' />
									<ExcelColumn label='Latitude' value='latitude' />
									<ExcelColumn label='Longitude' value='longitude' />
								</ExcelSheet>
							</ExcelFile>
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Row>
						<Grid cols='12 6 4 4'>
							<label>Pesquisar</label>
							<input className='form-control'
								placeholder='Pesquisar'
								type='text'
								value={this.state.pesquisar}
								onChange={e => {
									this.setState({ ...this.state, pesquisar: e.target.value });
								}} />
						</Grid>

						<Select
							cols='12 3 2 2'
							label='Ordenar por'
							options={[{
								id: 'data_validade_diesel',
								valor: 'Validade do Diesel'
							}, {
								id: 'preco_diesel',
								valor: 'Preço do Diesel'
							}]}
							value={this.state.ordenacao}
							onChange={value => {
								this.setState({
									...this.state,
									ordenacao: value
								});
							}} />

						<Select
							cols='12 3 2 2'
							label='Período'
							options={[{
								id: 1,
								valor: 'Vencido'
							}, {
								id: 30,
								valor: 'De 1 até 30 dias'
							}, {
								id: 60,
								valor: 'De 31 até 60 dias'
							}, {
								id: 90,
								valor: 'De 61 até 90 dias'
							}, {
								id: 120,
								valor: 'De 91 até 120 dias'
							}, {
								id: 10000,
								valor: 'Mais de 120 dias'
							}]}
							value={this.state.periodo}
							onChange={value => {
								this.setState({
									...this.state,
									periodo: value
								});
							}} />

						<Select
							cols='12 3 2 2'
							label='Estado'
							options={this.props.listaEstado}
							value={this.state.id_estado}
							onChange={value => {
								this.setState({
									...this.state,
									id_estado: value
								});
							}} />
					</Row>

					<div class="btn-group">
						<button 
							type='button'
							class={`btn btn-${this.state.modo == 'lista' ? 'info' : 'default'}`} style={{ width: 150 }}
							onClick={() => this.setState({ ...this.state, modo: 'lista' })}>
							Lista
						</button>
						<button
							type='button'
							class={`btn btn-${this.state.modo == 'mapa' ? 'info' : 'default'}`}
							style={{ width: 150 }}
							onClick={() => {
								this.props.getLista();
								this.setState({ ...this.state, modo: 'mapa' });
							}}>
							Mapa
						</button>
					</div>
					
					{this.state.modo == 'lista' ? (
						<Table responsive>
							
								<Tr>
									<Th>Nome</Th>
									<Th alignCenter>Rede</Th>
									<Th alignCenter>Atua</Th>									
									<Th alignCenter>Telefone</Th>
									<Th alignCenter>CNPJ</Th>
									<Th alignCenter>Cidade</Th>
									<Th alignCenter>Pernoite</Th>
									<Th alignCenter>Val. Diesel</Th>
									<Th alignRight>Vlr. Diesel</Th>
									<Th alignCenter>Val. Arla</Th>
									<Th alignCenter>Prazo</Th>
									<Th alignCenter>Status</Th>
									<Th></Th>
								</Tr>
							
							<TBody>


								<Tr>
									<Td bold colspan={7}>Média de todos os ativos</Td>
									<Td alignCenter></Td>
									<Td bold alignRight>R$ {FormatUtils.formatarValorTela(mediaAtivos, 2)}</Td>
									<Td></Td>
									<Td alignCenter></Td>
									<Td alignCenter></Td>
									<Td alignRight minWidth={150}></Td>
								</Tr>
								<Tr>
									<Td bold colspan={7}>Média de todos os ativos dentro do prazo</Td>
									<Td alignCenter></Td>
									<Td bold alignRight>R$ {FormatUtils.formatarValorTela(mediaNoPrazo, 2)}</Td>
									<Td></Td>
									<Td alignCenter></Td>
									<Td alignCenter></Td>
									<Td alignRight minWidth={150}></Td>
								</Tr>

								{lista.map(item => (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} 
										backgroundColor={item.desativado || item.cancelado ? '#ff9696' : null}>
										<Td>{item.nome}</Td>
										<Td alignCenter>{item.nome_rede}</Td>
										<Td alignCenter>{item.codigo}</Td>
										<Td alignCenter>{FormatUtils.formatarTelefone(item.telefone)}</Td>
										<Td alignCenter>{FormatUtils.formatarCNPJ(item.cnpj)}</Td>
										<Td alignCenter>{item.nome_cidade}</Td>
										<Td alignCenter>{item.pernoite ? 'Sim' : 'Não'}</Td>
										<Td alignCenter 
											style={{ 
												fontWeight: 'bold', 
												color: item.desativado || item.cancelado ? null : (item.dias_para_vencimento >= 1 && item.dias_para_vencimento < 5 ? '#000' : '#fff'), 
												backgroundColor: item.desativado || item.cancelado ? null : (item.dias_para_vencimento >= 10 ? '#00c853' : (item.dias_para_vencimento >= 5 ? '#29b6f6' : (item.dias_para_vencimento >= 1 ? '#ff0' : '#ff5252'))) }}>
											{DateFormat.formatarDataSqlParaTela(item.data_validade_diesel)}
										</Td>
										<Td alignRight>R$ {FormatUtils.formatarValorTelaDecimal(item.preco_diesel, 2)}</Td>
										<Td>{DateFormat.formatarDataSqlParaTela(item.data_validade_arla)}</Td>
										<Td alignCenter>{item.prazo || item.prazo_rede || ''}</Td>
										<Td alignCenter>{item.desativado ? 'Desativado' : (item.cancelado ? 'Cancelado para Negociação' : (item.dias_para_vencimento > 0 ? 'Dentro do Prazo' : 'Fora do Prazo'))}</Td>
										<Td alignRight minWidth={150}>
											<ButtonTable
												type={'success'}
												icon={'fas fa-dollar-sign'}
												visible={this.state.linhaSelecionada == item.id}
												disabled={this.props.permissoes.acesso_cadastro != 2}
												event={() => {
													this.props.setModoTela('negociacao', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />

											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={this.state.linhaSelecionada == item.id}
												disabled={this.props.permissoes.acesso_cadastro != 2}
												event={() => {
													this.props.setModoTela('cadastro', {
														...item
													});
													this.props.initForm({
														...item
													});
												}} />

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={this.state.linhaSelecionada == item.id}
												disabled={this.props.permissoes.acesso_cadastro != 2}
												event={() => {
													this.props.setModoTela('exclusao', {
														...item,
														senha: null
													});
													this.props.initForm({
														...item,
														senha: null
													});
												}} />
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					) : (
						<Map 
							pontos={lista.map(item => ({
								id: `posto-${item.id}`,
								nome: `${item.nome}\n`
									+ `${item.codigo || ''}\n`
									+ `Telefone: ${FormatUtils.formatarTelefone(item.telefone)}\n`
									+ `CNPJ: ${FormatUtils.formatarCNPJ(item.cnpj)}\n`
									+ `Cidade: ${item.nome_cidade || ''}\n`
									+ `Preço Diesel: R$ ${FormatUtils.formatarValorTela(item.preco_diesel, 4)}\n`
									+ `Validade Diesel: ${item.data_validade_diesel ? DateFormat.formatarDataSqlParaTela(item.data_validade_diesel) || '' : 'Sem validade'}\n`
									+ `Preço Arla: R$ ${FormatUtils.formatarValorTela(item.preco_arla, 4)}\n`
									+ `Validade Arla: ${item.data_validade_arla ? DateFormat.formatarDataSqlParaTela(item.data_validade_arla || '') : 'Sem validade'}\n`
									+ `Forma Pagamento: ${item.nome_forma_pagamento || 'Não Informada'}\n`,
								latitude: item.latitude,
								longitude: item.longitude,
								icone: item.dias_para_vencimento >= 10 ? 'marker-verde' : (
									item.dias_para_vencimento >= 5 ? 'marker-azul' : (item.dias_para_vencimento >= 1 ? 'marker-amarelo' : 'marker-vermelho')
								),
								nomeEvento: 'Editar',
								evento: () => {
									this.props.setModoTela('cadastro', {
										...item
									});
									this.props.initForm({
										...item
									});
								}
							}))}
							rota={this.state.rota}
							rotaCarregada={this.state.rotaCarregada}
							setRota={rota => {
								this.setState({
									...this.state,
									rotaCarregada: rota.rotaCarregada,
									rota: {
										pontos: rota ? rota.pontos : [],
										itens: rota ? rota.itens : [],
										overview_polyline: rota.overview_polyline || null
									},
									postos: rota ? rota.pontos : []
								});
							}} />
					)}
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.posto,
	modoTela: state.posto.modoTela,
	lista: state.posto.lista,
	listaEstado: state.posto.listaEstado,
	permissoes: state.usuario.permissoes
});
const mapDispatchToProps = dispatch => bindActionCreators({setModoTela, initForm, salvar, excluir, getListaCidade, getLista, getListaRede, getListaFormaPagamento, getListaEstado }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Posto);
